import React from 'react'
import { Cell } from 'rsuite-table'
import './EnquiryStatusCell.scss'

type RowData = {
  [key: string]: string | boolean
}

type EnquiryStatusCellProps = {
  rowData?: RowData,
  dataKey: string
}

const EnquiryStatusCell: React.FC<EnquiryStatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey]
  const lowerCaseStatus = typeof status === 'string' ? status.toLowerCase() : ''

  let statusClass = ''
  if (lowerCaseStatus === 'resolved') {
    statusClass = 'status-resolved'
  } else if (lowerCaseStatus === 'pending') {
    statusClass = 'status-pending'
  }

  return (
    <Cell {...props}>
      {status ? (
        <span className={`status-cell ${statusClass}`}>{status}</span>
      ) : (
        <span className="status-blank">-</span>
      )}
    </Cell>
  )
}

export default EnquiryStatusCell
